import { positioningEngine, validateType } from './utils';

export default class Popping {
	scrollView;
	target;
	dialog;
	options;
	modifiers;
	pluginDumps;

	static create(...props) {
		return new Popping(...props);
	}

	constructor(
		target,
		dialog,
		{ plugins = [], modifiers = [], ...options } = {}
	) {
		const mix = [target, dialog]
		mix.forEach((node, index) => {
			validateType(node, ['node', 'element'], `Popping argument \`${index}\``)
		}) 
		const d = document
		const offsetParent = dialog.offsetParent
		const allowRootRelative = offsetParent === d.body
		const defaultOpt = {
			placement: 'bottom',
			offset: [10, 10],
			rotateArrow: 45,
			useTranslatePositioning: false,
			arrowPointCenter: false,
			allowRootRelative,
			allowFlipManifestation: false,
			allowPersistent: false,
		};
		this.scrollView = allowRootRelative ? d.documentElement : offsetParent
		this.target = target;
		this.dialog = dialog;
		this.options = { ...defaultOpt, ...options };
		this.modifiers = modifiers;
		this.pluginDumps = plugins.map((plugin) => plugin(this));
		Object.keys(defaultOpt).forEach((key) => {
			validateType(this.options[key], 
				[ key === 'rotateArrow' 
				? 'number' 
				: key === 'placement' 
					? 'string' 
					: key === 'offset' 
						? 'array[number]' 
						: 'boolean'
				], 
				`Popping options \`${key}\``)
		})
		this.updatePosition();
	}

	updatePosition() {
		let options;

		this.modifiers.forEach((modifier) => {
			const optiondumps = modifier(this);
			if (optiondumps) {
				options = {
					...this.options,
					...optiondumps,
				};
			}
		});

		positioningEngine(this, options || this.options);
	}

	destroy() {
		this.pluginDumps.forEach((plugin) => {
			plugin.destroy();
		});
	}

	updateOptions(options = {}) {
		this.options = { ...this.options, ...options };
	}
}
